var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStool = function SvgStool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#stool_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    x: 16,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M41.938 28.25a1.06 1.06 0 0 1-1.063 1.063H38.75a1.062 1.062 0 1 1 0-2.125h2.125a1.06 1.06 0 0 1 1.063 1.062m6.948 17.683.468 3.267a2.127 2.127 0 0 1-2.104 2.425h-8.5a2.125 2.125 0 0 1-2.104-2.425l.468-3.267a12.76 12.76 0 0 1-6.864-11.308 1.06 1.06 0 0 1 1.063-1.062h2.125v-8.5a2.125 2.125 0 0 1 2.124-2.125h14.876a2.125 2.125 0 0 1 2.124 2.125v8.5h2.126a1.06 1.06 0 0 1 1.062 1.062 12.76 12.76 0 0 1-6.864 11.308m-13.324-12.37h14.876v-8.5H35.562zm11.299 13.214a12.77 12.77 0 0 1-7.722 0L38.75 49.5h8.5zm6.71-11.09H32.429a10.625 10.625 0 0 0 21.144 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "stool_svg__a",
    width: 84,
    height: 84,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2710_35592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2710_35592",
    result: "shape"
  })))));
};
export default SvgStool;